import script from "./MailBoxContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MailBoxContent.vue?vue&type=script&setup=true&lang=js"

import "./MailBoxContent.vue?vue&type=style&index=0&id=89b21ec4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89b21ec4"]])

export default __exports__